// extracted by mini-css-extract-plugin
export var subTitle = "unifiedSearchNoResults-module--subTitle--7196e";
export var suggestedSearches = "unifiedSearchNoResults-module--suggestedSearches--41280";
export var suggestedSearchesTitle = "unifiedSearchNoResults-module--suggestedSearchesTitle--7cfd7";
export var title = "unifiedSearchNoResults-module--title--8ecd3";
export var unifiedSearchNoResults = "unifiedSearchNoResults-module--unifiedSearchNoResults--624bf";